if (!customElements.get("m-product-tabs")) {
  class e extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        loadMoreBtn: "[data-load-more-product]",
        productsContainer: "[data-products-container]",
        tabContent: [".m-tab-content"]
      };
      this.tabSliders = [];
      this.sliderEnabled = this.dataset.enableSlider === "true";
      this.mobileSliderDisable = this.dataset.mobileDisableSlider === "true";
      this.buttonType = this.dataset.buttonType;
      this.domNodes = queryDomNodes(this.selectors, this);
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.items = this.dataset.items;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      if (this.sliderEnabled) {
        for (let e of this.domNodes.tabContent) {
          this.initSliderByScreenSize(e);
          document.addEventListener("matchMobile", () => {
            this.initSliderByScreenSize(e);
          });
          document.addEventListener("unmatchMobile", () => {
            this.initSliderByScreenSize(e);
          });
        }
      }

      if (!this.sliderEnabled && this.buttonType === "load") {
        this.canLoad = true;
        this.currentPage = 1;
        for (let e of this.domNodes.tabContent) {
          this.initLoadMore(e);
        }
      }

      if (MinimogTheme.config.mqlMobile && this.mobileSliderDisable && this.buttonType === "load") {
        this.canLoad = true;
        this.currentPage = 1;
        for (let e of this.domNodes.tabContent) {
          this.initLoadMore(e);
        }
      }

      document.addEventListener("matchMobile", () => {
        if (MinimogTheme.config.mqlMobile && this.mobileSliderDisable && this.buttonType === "load") {
          this.canLoad = true;
          this.currentPage = 1;
          for (let e of this.domNodes.tabContent) {
            this.initLoadMore(e);
          }
        }
      });

      this.initTabs();
      this.initMobileSelect();

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (e) => {
          if (!e.target.classList.contains("m-tab-content")) return;
          const t = e.target && e.target.dataset.index;
          this.tabs.setActiveTab(t);
        });
      }
    }

    initTabs() {
      this.tabs = new MinimogTheme.Tabs(this, (e) => {
        const t = e.getAttribute("href");
        const i = this.querySelector(t + " .swiper-container");
        const s = this.querySelector(t + " .m-slider-controls");
        if (i && i.swiper) i.swiper.update();
        const o = i && (i.querySelector(".m-image") || i.querySelector(".m-placeholder-svg"));
        if (o && s) {
          const e = o.clientHeight;
          s.style.setProperty("--offset-top", parseInt(e) / 2 + "px");
        }
      });
    }

    initSliderByScreenSize(e) {
      const t = this.dataset.mobileDisableSlider === "true";
      const i = e.querySelector(".m-mixed-layout__wrapper");
      const s = e.querySelector(".m-slider-controls");

      if (MinimogTheme.config.mqlMobile && t) {
        s && s.classList.add("m:hidden");
        i.classList.remove("swiper-container");
        // ✅ Enhanced cleanup when destroying slider
        if (i.swiper) {
          // Clean up custom arrow events before destroying
          const customPrev = e.querySelector(".custom-swiper-arrow.swiper-prev");
          const customNext = e.querySelector(".custom-swiper-arrow.swiper-next");
          if (customPrev && customPrev._swiperPrevHandler) {
            customPrev.removeEventListener("click", customPrev._swiperPrevHandler);
            customPrev.removeEventListener("touchend", customPrev._swiperPrevHandler);
          }
          if (customNext && customNext._swiperNextHandler) {
            customNext.removeEventListener("click", customNext._swiperNextHandler);
            customNext.removeEventListener("touchend", customNext._swiperNextHandler);
          }
          i.swiper.destroy(false, true);
        }
      } else {
        s && s.classList.remove("m:hidden");
        setTimeout(() => {
          this.initSlider(e);
        });
      }
    }

    initSlider(e) {
      const t = e.querySelector(".m-product-list");
      const i = e.querySelector(".m-mixed-layout__wrapper");
      const s = e.querySelector(".m-slider-controls");
      const o = s?.querySelector(".m-slider-controls__button-prev");
      const r = s?.querySelector(".m-slider-controls__button-next");
      const n = e.querySelector(".swiper-wrapper")?.childElementCount;

      if (parseInt(this.items) >= n) {
        s && s.classList.add("m:hidden");
        t.classList.add("m-mixed-layout--mobile-grid");
        return;
      }

      i && i.classList.add("swiper-container");

      let a = new MinimogLibs.Swiper(i, {
        slidesPerView: 2,
        showPagination: this.showPagination,
        showNavigation: this.showNavigation,
        loop: !this.enableFlashsale,
        pagination: !!this.showPagination && {
          el: e.querySelector(".swiper-pagination"),
          clickable: true
        },
        breakpoints: {
          768: { slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items) },
          992: { slidesPerView: parseInt(this.items) >= 4 ? 4 : parseInt(this.items) },
          1280: { slidesPerView: parseInt(this.items) }
        },
        threshold: 2,
        // ✅ Enhanced mobile touch handling
        touchRatio: 1,
        touchAngle: 45,
        simulateTouch: true,
        allowTouchMove: true,
        touchStartPreventDefault: false,
        touchMoveStopPropagation: false,
        on: {
          init: function () {
            setTimeout(() => {
              const t = e.querySelector(".m-image") || e.querySelector(".m-placeholder-svg");
              if (t && s) {
                const eHeight = t.clientHeight;
                s.style.setProperty("--offset-top", parseInt(eHeight) / 2 + "px");
                o?.classList.remove("m:hidden");
                r?.classList.remove("m:hidden");
              }

              this.emit("slideChange");
            }, 200);
          },

          breakpoint: (swiperInstance, t) => {
            if (s) {
              const { slidesPerView: i } = t;
              n > i ? (s.classList.remove("m:hidden"), swiperInstance.allowTouchMove = true)
                    : (s.classList.add("m:hidden"), swiperInstance.allowTouchMove = false);
            }
          },

          slideChange: function () {
            const swiper = this;
            const progressBar = e.querySelector(".custom-swiper-progress-bar .progress-bar-fill");
            if (progressBar) {
              // ✅ Fixed progress calculation for all scenarios
              let totalSlides, activeIndex;
              
              if (swiper.loopedSlides && swiper.slides.length > swiper.loopedSlides * 2) {
                // Loop mode calculation
                totalSlides = swiper.slides.length - swiper.loopedSlides * 2;
                activeIndex = swiper.realIndex;
              } else {
                // Non-loop mode calculation
                totalSlides = swiper.slides.length;
                activeIndex = swiper.activeIndex;
              }
              
              // Ensure we don't divide by zero and handle edge cases
              if (totalSlides > 0) {
                const progress = Math.min(100, Math.max(0, ((activeIndex + 1) / totalSlides) * 100));
                progressBar.style.width = `${progress}%`;
              }
            }
          }
        }
      });

      if (this.showNavigation) {
        o?.addEventListener("click", () => a.slidePrev());
        r?.addEventListener("click", () => a.slideNext());
      }

      // Bind custom outside arrows
      this.bindCustomArrowEvents(e, a);
    }

    // ✅ Fixed method for custom arrows with proper event handling
    bindCustomArrowEvents(e, swiperInstance) {
      const customPrev = e.querySelector(".custom-swiper-arrow.swiper-prev") || document.querySelector(".custom-swiper-arrow.swiper-prev");
      const customNext = e.querySelector(".custom-swiper-arrow.swiper-next") || document.querySelector(".custom-swiper-arrow.swiper-next");

      if (customPrev && customNext) {
        // Remove any existing event listeners to prevent duplicates
        customPrev.removeEventListener("click", customPrev._swiperPrevHandler);
        customNext.removeEventListener("click", customNext._swiperNextHandler);
        
        // Create new handlers
        customPrev._swiperPrevHandler = (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (swiperInstance && typeof swiperInstance.slidePrev === 'function') {
            swiperInstance.slidePrev();
          }
        };
        
        customNext._swiperNextHandler = (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (swiperInstance && typeof swiperInstance.slideNext === 'function') {
            swiperInstance.slideNext();
          }
        };
        
        // Add new event listeners
        customPrev.addEventListener("click", customPrev._swiperPrevHandler);
        customNext.addEventListener("click", customNext._swiperNextHandler);
        
        // Also add touch events for better mobile support
        customPrev.addEventListener("touchend", customPrev._swiperPrevHandler);
        customNext.addEventListener("touchend", customNext._swiperNextHandler);
      }
    }

    initMobileSelect() {
      this.select = this.querySelector("[data-tab-select]");
      this.select.addEventListener("change", () => {
        this.tabs.setActiveTab(parseInt(this.select.value));
        const e = this.tabs?.currentTab?.querySelector(".swiper-container");
        const t = this.tabs?.currentTab?.querySelector(".m-slider-controls");
        const i = t?.querySelector(".m-slider-controls__button-prev");
        const s = t?.querySelector(".m-slider-controls__button-next");

        if (e?.swiper) e.swiper.update();

        const o = e?.querySelector(".m-image");
        if (o && t) {
          const eHeight = o.clientHeight;
          t.style.setProperty("--offset-top", parseInt(eHeight) / 2 + "px");
          i?.classList.remove("m:hidden");
          s?.classList.remove("m:hidden");
        }
      });
    }

    initLoadMore(e) {
      addEventDelegate({
        context: e,
        selector: this.selectors.loadMoreBtn,
        handler: (t) => {
          t.preventDefault();
          this.handleLoadMore(e);
        }
      });
    }

    handleLoadMore(e) {
      const t = e.querySelector(this.selectors.loadMoreBtn);
      const i = e.querySelector(this.selectors.productsContainer);
      let s = parseInt(e.dataset.page);
      const o = e.dataset.totalPages;

      this.toggleLoading(t, true);
      const r = `${e.dataset.url}?page=${s + 1}&section_id=${this.id}`;

      fetchCache(r).then((response) => {
        s++;
        e.dataset.page = s;
        this.toggleLoading(t, false);

        const n = generateDomFromString(response);
        const a = e.getAttribute("id");
        const l = n.querySelector(`#${a} ${this.selectors.productsContainer}`);

        if (l) {
          Array.from(l.childNodes).forEach((node) => {
            i.appendChild(node);
          });
        }

        if (s >= parseInt(o)) {
          t && t.remove();
        }
      });

      t.blur();
    }

    toggleLoading(e, t) {
      if (e) {
        t ? e.classList.add("m-spinner-loading") : e.classList.remove("m-spinner-loading");
      }
    }
  }

  customElements.define("m-product-tabs", e);
}
